import { SeasonTrades } from "../../schemas/Trade";
import { manager } from "../stringConstants";

export const yevgenyTrades: SeasonTrades[] = [
  {
    season: "2011/12",
    allTrades: [
      {
        otherTeam: manager.oded,
        sentAway: "Dorell Wright and DJ Augustin",
        gotInReturn: "Kyrie Irving",
      },
      {
        otherTeam: manager.oded,
        sentAway: "Steve Nash and Andrew Bogut",
        gotInReturn: "Russell Westbrook",
      },
      {
        otherTeam: manager.itay,
        sentAway: "Kyrie Irving and Emeka Okafor",
        gotInReturn: "Andrew Bynum",
      },
    ],
  },

  {
    season: "2012/13",
    allTrades: [
      {
        otherTeam: manager.mati,
        sentAway: "Jameer Nelson",
        gotInReturn: "Michael Beasley",
      },
      {
        otherTeam: manager.mati,
        sentAway: "Tyreke Evans and Ryan Anderson",
        gotInReturn: "Marcin Gortat and Mike Dunleavy Jr",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Kevin Martin",
        gotInReturn: "Nikola Vucevic",
      },
    ],
  },

  {
    season: "2013/14",
    allTrades: [
      {
        otherTeam: manager.dom,
        sentAway: "Russell Westbrook and Paul Millsap",
        gotInReturn: "Eric Bledsoe and Chris Bosh",
      },
    ],
  },
  {
    season: "2014/15",
    allTrades: [
      {
        otherTeam: manager.alon,
        sentAway: "Nikola Vucevic and Isaiah Thomas",
        gotInReturn: "Andrew Wiggins and Markieff Morris",
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Robin Lopez",
        gotInReturn: "Gorgui Dieng",
      },
      {
        otherTeam: manager.oded,
        sentAway: "Trey Burke",
        gotInReturn: "Joakim Noah",
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Joakim Noah and Tobias Harris",
        gotInReturn: "Rudy Gay",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Tyson Chandler and Gorgui Dieng",
        gotInReturn: "DeAndre Jordan",
      },
      {
        otherTeam: manager.itay,
        sentAway: "Chris Bosh",
        gotInReturn: "Thaddeus Young",
      },
      {
        otherTeam: manager.oded,
        sentAway: "Trey Burke",
        gotInReturn: "Joakim Noah",
      },
    ],
  },

  {
    season: "2015/16",
    allTrades: [
      {
        otherTeam: manager.kobe,
        sentAway: "DeAndre Jordan and Zach LaVine",
        gotInReturn: "Serge Ibaka and Julius Randle",
      },
      {
        otherTeam: manager.mati,
        sentAway: "Thaddeus Young",
        gotInReturn: "Dirk Nowitzki",
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Dirk Nowitzki and Rudy Gay",
        gotInReturn: "Rodney Hood",
        amongWorstTrades: true
      },
      {
        otherTeam: manager.ariel,
        sentAway: "Chandler Parsons",
        gotInReturn: "Monta Ellis",
      },
      {
        otherTeam: manager.dom,
        sentAway: "Rodney Hood, DeMar DeRozan and Rajon Rondo",
        gotInReturn: "Klay Thompson",
      },
      {
        otherTeam: manager.nissim,
        sentAway: "Damian Lillard and Serge Ibaka",
        gotInReturn: "Kawhi Leonard",
      },
    ],
  },
  {
    season: "2016/17",
    allTrades: [
      {
        otherTeam: manager.idan,
        sentAway: "Klay Thompson and 4th pick in Veterans Draft",
        gotInReturn: "John Wall and 8th pick in Veterans Draft",
      },
      {
        otherTeam: manager.zeev,
        sentAway:
          "Kawhi Leonard, Julius Randle, Rajon Rondo and Marquese Chriss",
        gotInReturn: "Rudy Gobert, Devin Booker and Klay Thompson",
        amongBestTrades: true,
      },
      {
        otherTeam: manager.ilya,
        sentAway: "Bradley Beal and Jahlil Okafor",
        gotInReturn: "Marc Gasol and Kris Dunn",
      },
      {
        otherTeam: manager.ilya,
        sentAway: "Elfrid Payton",
        gotInReturn: "Al Horford",
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Derrick Rose",
        gotInReturn: "Ryan Anderson",
      },
      {
        otherTeam: manager.idan,
        sentAway: "Rudy Gobert and Klay Thompson",
        gotInReturn: "Kristaps Porzingis and Danilo Gallinari",
      },
      {
        otherTeam: manager.itay,
        sentAway: "Emmanuel Mudiay",
        gotInReturn: "Pau Gasol",
      },
      {
        otherTeam: manager.shiran,
        sentAway: "Marc Gasol",
        gotInReturn: "Otto Porter Jr",
      },
    ],
  },
  {
    season: "2017/18",
    allTrades: [
      {
        otherTeam: manager.dom,
        sentAway: "Dennis Schroder and Lauri Markkanen",
        gotInReturn: "Paul Millsap and Rodney Hood",
      },
      {
        otherTeam: manager.dom,
        sentAway: "Nikola Vucevic",
        gotInReturn: "Taj Gibson",
      },
      {
        otherTeam: manager.ariel,
        sentAway: "John Wall",
        gotInReturn: "Taurean Prince and Carmelo Anthony",
      },
      {
        otherTeam: manager.dom,
        sentAway: "Taurean Prince",
        gotInReturn: "Derrick Favors",
      },
      {
        otherTeam: manager.shiran,
        sentAway: "Al Horford, Evan Fournier and Larry Nance Jr",
        gotInReturn: "Jimmy Butler and Marquese Chriss",
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Reggie Jackson and Andrew Wiggins",
        gotInReturn: "Goran Dragic",
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Kristaps Porzingis",
        gotInReturn: "Khris Middleton",
      },
      {
        otherTeam: manager.itay,
        sentAway: "Marc Gasol",
        gotInReturn: "Enes Kanter and Tobias Harris",
      },
      {
        otherTeam: manager.itay,
        sentAway: "Carmelo Anthony",
        gotInReturn: "Elfrid Payton",
      },
      {
        otherTeam: manager.ilya,
        sentAway: "Jimmy Butler",
        gotInReturn: "Blake Griffin",
        amongWorstTrades: true,
      },
    ],
  },
  {
    season: "2018/19",
    allTrades: [
      {
        otherTeam: manager.ilya,
        sentAway: "7th and 16th picks",
        gotInReturn: "2nd (became Luka Doncic) and 38th picks",
        amongBestTrades: true,
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Marvin Bagley",
        gotInReturn: "Bobby Portis",
      },
      {
        otherTeam: manager.itay,
        sentAway: "Tobias Harris, Khris Middleton and JJ Redick",
        gotInReturn: "Trae Young, Kevin Love and Harrison Barnes",
        amongBestTrades: true,
      },
      {
        otherTeam: manager.dom,
        sentAway: "Luka Doncic and Trae Young",
        gotInReturn: "Deandre Ayton, Paul Millsap and Dario Saric",
        amongWorstTrades: true,
      },
      {
        otherTeam: manager.mati,
        sentAway: "Jarret Allen and Rudy Gay",
        gotInReturn: "Clint Capela",
      },
      {
        otherTeam: manager.zeev,
        sentAway: "Larry Nance Jr",
        gotInReturn: "Shai Gilgeous-Alexander",
        amongBestTrades: true,
      },
      {
        otherTeam: manager.shiran,
        sentAway: "Collin Sexton",
        gotInReturn: "Tim Hardaway Jr",
      },
    ],
  },
  {
    season: "2019/20",
    allTrades: [
      {
        otherTeam: manager.kobe,
        sentAway: "Joe Ingles",
        gotInReturn: "Rui Hachimura",
      },
      {
        otherTeam: manager.ilya,
        sentAway: "Rui Hachimura",
        gotInReturn: "Jeff Teague",
      },
      {
        otherTeam: manager.ilya,
        sentAway: "Kevin Love",
        gotInReturn: "Jamal Murray",
      },
      {
        otherTeam: manager.ilya,
        sentAway: "Kevin Huerter and Dennis Schroder",
        gotInReturn: "Steven Adams",
      },
      {
        otherTeam: manager.ilya,
        sentAway: "Clint Capela",
        gotInReturn: "Jrue Holiday",
      },
    ],
  },
  {
    season: "2020/21",
    allTrades: [
      {
        otherTeam: manager.ilya,
        sentAway: "Kyrie Irving and Cole Anthony",
        gotInReturn: "Kawhi Leonard",
      },
      {
        otherTeam: manager.ariel,
        sentAway: "Clint Capela",
        gotInReturn: "Kristaps Porzingis and DeAaron Fox",
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Shai Gilegeous-Alexander",
        gotInReturn: "Khris Middleton",
        amongWorstTrades: true,
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Nerlens Noel and 2nd round pick",
        gotInReturn: "Julius Randle and 3rd round pick",
      },
      {
        otherTeam: manager.nissim,
        sentAway: "LaMelo Ball and Steven Adams",
        gotInReturn: "Pascal Siakam",
        amongWorstTrades: true,
      },
    ],
  },
  {
    season: "2021/22",
    allTrades: [
      {
        otherTeam: manager.rony,
        sentAway: "Julius Randle and Jae'Sean Tate",
        gotInReturn: "Alperen Sengun",
        amongBestTrades: true,
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Lonzo Ball and Isaiah Stewart",
        gotInReturn: "Jusuf Nurkic",
      },
      {
        otherTeam: manager.rony,
        sentAway: "Ayo Dosunmu",
        gotInReturn: "Mike Conley",
      },
      {
        otherTeam: manager.rony,
        sentAway: "Chris Duarte",
        gotInReturn: "Julius Randle",
      },
    ],
  },
  {
    season: "2022/23",
    allTrades: [
      {
        otherTeam: manager.rony,
        sentAway: "Kristaps Porzingis",
        gotInReturn: "Jabari Smith Jr"
      },
      {
        otherTeam: manager.mati,
        sentAway: "Jrue Holiday",
        gotInReturn: "Tobias Harris and Anfernee Simons"
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Jalen Duren and D'Angelo Russell",
        gotInReturn: "Ja Morant and Harrison Barnes",
        amongWorstTrades: true
      }
    ],
  },
  {
    season: "2023/24",
    allTrades: [
      {
        otherTeam: manager.rony,
        sentAway: "Jabari Smith",
        gotInReturn: "Scoot Henderson"
      },
      {
        otherTeam: manager.yoni,
        sentAway: "CJ McCollum and Brandon Ingram",
        gotInReturn: "De'Aaron Fox",
        amongBestTrades: true
      }
    ]
  },
  {
    season: "2024/25",
    allTrades: [
      {
        otherTeam: manager.yevgeny,
        sentAway: "Jordan Poole", 
        gotInReturn: "Myles Turner"
      },
    ]
  }
];
